'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { OverlayStackingContext } from '#pplx/frontend/overlay-stacking/useOverlayStacking.js';
/**
 * Selects the overlay stacking mode for an app root during rollout or rollback.
 *
 * Deprecated pattern: nesting this provider around one overlay with `mode="legacy"`
 * to keep its content in a local container. That changes the mode of every
 * descendant overlay and restores Surface-based portal selection. Use an
 * explicit, restricted host for content that must remain in a local layout.
 */
export function OverlayStackingProvider({ mode, children, }) {
    return _jsx(OverlayStackingContext.Provider, { value: mode, children: children });
}
//# sourceMappingURL=index.js.map